import { useLocation } from 'react-router';

type SearchParams = {
  [key: string]: string;
};

export const useSearchParams = () => {
  const location = useLocation();

  const searchParams = location.search
    .slice(1)
    .split('&')
    .map((p: string) => p.split('='))
    .reduce(
      (obj: SearchParams, [key, value]: [string, string]) => ({
        ...obj,
        [key]: value,
      }),
      {},
    );

  return searchParams;
};
